import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import InventoryCategoryListing from "./InventoryCategoryListing";
import InventoryCategoryCreate from "./InventoryCategoryCreate";
import { InventoryCategoryEdit } from "./InventoryCategoryEdit";

export const InventoryCategoryAdmin = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route
                exact
                path={`${path}`}
                render={() => {
                    return <InventoryCategoryListing path={path} />;
                }}
            />
            <Route
                exact
                path={`${path}/create`}
                render={() => {
                    return <InventoryCategoryCreate path={path} />;
                }}
            />
            <Route
                exact
                path={`${path}/edit/:uuid`}
                render={(props) => {
                    const {
                        match: {
                            params: { uuid },
                        },
                    } = props;
                    return <InventoryCategoryEdit path={path} uuid={uuid} />;
                }}
            />
        </Switch>
    );
};

export default InventoryCategoryAdmin;
